<template>
  <div class="about">
    <div>
      <div class="row">
        <!-- Title -->
        <div class="stage-title">Przelicz stany minimalne i normy</div>
        <hr/>
      </div>
      <div class="row">
        <div class="col-md-4">
          <button
              class="btn btn-outline-info"
              @click="calculateStockStandard('OTC')"
          >
            OTC
          </button>
        </div>
        <div class="col-md-4">
          <button
              class="btn btn-outline-info"
              @click="calculateStockStandard('RX100')"
          >
            RX 100%
          </button>
        </div>
        <div class="col-md-4">
          <button
              class="btn btn-outline-info"
              @click="calculateStockStandard('URZ')"
          >
            Urzędowe
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {useCommonAppModule, useLazyLoaderModule} from "@/state/pinia";
import {useOrdersManagerModule} from "@/state/pinia";

export default {
  name: "OrdersManagerStockStandard",
  computed: {
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    ordersModule() {
      return useOrdersManagerModule();
    },

  },
  methods: {
    calculateStockStandard(type) {
      this.commonModule.setProcessGUID("STOCK_STANDARD_CALCULATIONS");
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setDisplayProgressBar(true);
      const calculateStockStandardRequest = {
        productsType: type,
      };
      this.ordersModule.httpCalculateStockStandardForType(
          calculateStockStandardRequest
      ).then(() => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
      });
    },
  },
  watch: {},
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
  },
};
</script>

<style scoped></style>
